export const sortReadOnlyTimesheetRows = timesheetRows => {
  const readOnlyRows = timesheetRows.filter(row => row.readOnly);
  const sortedRows = timesheetRows.filter(row => !row.readOnly).concat(readOnlyRows);

  return sortedRows;
};
